export const APROBADO= 'Aprobado';
export const STOCK_VERIFICADO_CON_DIFICULTAD = 'Stock verificado con dificultad';
export const EN_CURSO = 'Envio confirmado';
export const CERRADO = 'Cerrado';
export const CERRADO_RESUELTO = 'Cerrado resuelto';
export const CERRADO_CON_INCONVENIENTES = 'Cerrado con incovenientes';
export const CANCELADO = 'Cancelado';
export const PENDIENTE = 'Pendiente';